module.exports = __webpack_public_path__ + "static/phigora-macbook@2x-300x266-e40abe801540ffb04499c9bd8daf3fe9.png";